const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths
    .filter((width) => width <= image["width"])
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.srcset = generateSrcset(
    previewImage,
    [165, 360, 533, 720, 940, 1066]
  );
  newImage.loading = "eager";
  newImage.src = previewImage["src"];
  return newImage;
};

const cardSwatchSelections = new WeakMap();
const boundCardSwatches = new WeakSet();

const waitForCardImage = (image) => {
  if (typeof image.decode === "function") return image.decode();
  if (image.complete) {
    return image.naturalWidth > 0 ? Promise.resolve() : Promise.reject();
  }
  return new Promise((resolve, reject) => {
    const cleanup = () => {
      image.removeEventListener("load", onLoad);
      image.removeEventListener("error", onError);
    };
    const onLoad = () => {
      cleanup();
      resolve();
    };
    const onError = () => {
      cleanup();
      reject();
    };
    image.addEventListener("load", onLoad);
    image.addEventListener("error", onError);
  });
};

const preserveCardImageFit = (source, destination) => {
  const style = window.getComputedStyle(source);
  destination.style.objectFit = style.objectFit;
  destination.style.objectPosition = style.objectPosition;
};

const checkSwatches = () => {
  document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
    wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
      if (boundCardSwatches.has(input)) return;
      boundCardSwatches.add(input);
      input.addEventListener("click", (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (event.currentTarget.checked && primaryImage) {
          const selection = {};
          cardSwatchSelections.set(wrapper, selection);
          const isCurrentSelection = () =>
            cardSwatchSelections.get(wrapper) === selection && wrapper.isConnected;
          wrapper
            .querySelector(".js-color-swatches-link")
            .setAttribute("href", event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper
              .querySelector('.card__add-to-cart button[name="add"]')
              .setAttribute("aria-disabled", false);
            wrapper
              .querySelector('.card__add-to-cart button[name="add"] > span')
              .classList.remove("hidden");
            wrapper
              .querySelector(
                '.card__add-to-cart button[name="add"] .sold-out-message'
              )
              .classList.add("hidden");
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
              event.currentTarget.dataset.variantId;
          }

          const currentColor = event.currentTarget.value;
          const variantId = event.currentTarget.dataset.variantId;
          const optionIndex =
            Number(input.closest("[data-option-position]")?.dataset.optionPosition) - 1;

          jQuery.getJSON(
            window.Shopify.routes.root + `products/${handleProduct}.js`,
            async function (product) {
              if (!isCurrentSelection()) return;
              const matchesOption = (item) =>
                Number.isInteger(optionIndex) && optionIndex >= 0
                  ? item.options[optionIndex] === currentColor
                  : item.options.includes(currentColor);
              const variant =
                product.variants.find(
                  (item) =>
                    String(item.id) === variantId &&
                    item.featured_media != null &&
                    matchesOption(item)
                ) ||
                product.variants.find(
                  (item) => item.featured_media != null && matchesOption(item)
                );

              if (!variant) return;
              try {
                const newPrimaryImage = createImageElement(
                  variant["featured_media"],
                  primaryImage.className,
                  primaryImage.sizes,
                  product.title
                );

                if (newPrimaryImage.src === primaryImage.src) return;
                const imageToShow =
                  secondaryImage &&
                  new URL(secondaryImage.src).pathname ===
                    new URL(newPrimaryImage.src).pathname
                    ? secondaryImage
                    : newPrimaryImage;
                imageToShow.loading = "eager";
                await waitForCardImage(imageToShow);
                if (!isCurrentSelection()) return;

                const currentPrimaryImage = wrapper.querySelector(".media--first");
                if (!currentPrimaryImage) return;
                // Keep the existing framing, and keep its image visible until the next is ready.
                preserveCardImageFit(currentPrimaryImage, imageToShow);
                if (imageToShow === secondaryImage) {
                  currentPrimaryImage.remove();
                  secondaryImage.classList.remove("media--second");
                  secondaryImage.classList.add("media--first");
                } else {
                  currentPrimaryImage.replaceWith(newPrimaryImage);
                  if (secondaryImage) secondaryImage.remove();
                }
              } catch {
                // A failed image leaves the current product picture in place.
              }
            }
          );
        }
      });
    });
  });
};

function colorSwatches() {
  checkSwatches();

  document.addEventListener("shopify:section:load", checkSwatches);
}

(function () {
  colorSwatches();
})();
